(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-filters-mobile"] && !Shopify.designMode) return;
  try {
    (function() {
    const toggleBtn = document.getElementById('mobile-filter-toggle');
    const modal = document.getElementById('mobile-filter-modal');
    const closeBtn = document.getElementById('mobile-filter-close');
    const doneBtn = document.getElementById('mobile-filter-done');

    function openModal() {
      if (modal) {
        modal.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
      }
    }

    function closeModal() {
      if (modal) {
        modal.classList.add('hidden');
        document.body.style.overflow = '';
      }
    }

    if (toggleBtn) {
      toggleBtn.addEventListener('click', openModal);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }

    if (doneBtn) {
      doneBtn.addEventListener('click', closeModal);
    }

    if (modal) {
      modal.addEventListener('click', function(e) {
        if (e.target === modal) {
          closeModal();
        }
      });
    }

    // Mobile sort
    const mobileSort = document.getElementById('mobile-collection-sort');
    if (mobileSort) {
      const urlParams = new URLSearchParams(window.location.search);
      const currentSort = urlParams.get('sort_by') || 'manual';
      mobileSort.value = currentSort;

      mobileSort.addEventListener('change', function() {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        url.searchParams.delete('page');
        url.searchParams.set('grid_page', '1');
        window.location.href = url.toString();
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-filters"] && !Shopify.designMode) return;
  try {
    (function() {
    function setAccordionOpen(group, shouldOpen) {
      var toggle = group.querySelector('[data-filter-toggle]');
      var panel = group.querySelector('[data-filter-panel]');
      if (!toggle || !panel) return;
      group.setAttribute('data-open', shouldOpen ? 'true' : 'false');
      toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      panel.classList.toggle('hidden', !shouldOpen);
    }

    const urlParams = new URLSearchParams(window.location.search);
    const inStock = urlParams.get('inStock') === '1';
    const activeFinishes = urlParams.getAll('finish');
    const activeSizes = urlParams.getAll('size');
    const activeColours = urlParams.getAll('colour');

    function setFirstGridPage(url) {
      url.searchParams.delete('page');
      url.searchParams.set('grid_page', '1');
    }

    function toArray(value) {
      if (value == null) return [];
      if (Array.isArray(value)) return value.map(function(v) { return String(v).trim(); }).filter(Boolean);
      var s = String(value).trim();
      return s ? [s] : [];
    }

    function buildValueMap(products, key) {
      var map = new Map();
      products.forEach(function(product) {
        toArray(product[key]).forEach(function(val) {
          map.set(val, (map.get(val) || 0) + 1);
        });
      });
      return map;
    }

    function renderFilterGroup(root, valueMap, activeValues, paramName) {
      const container = root.querySelector('[data-filter-options="' + paramName + '"]');
      if (!container) return;

      if (valueMap.size === 0) {
        container.innerHTML = '<p class="text-gray text-sm">No ' + paramName + ' options found.</p>';
        return;
      }

      const sorted = Array.from(valueMap.entries())
        .sort(function(a, b) { return b[1] - a[1] || a[0].localeCompare(b[0]); });

      container.innerHTML = sorted.map(function(entry) {
        var name = entry[0];
        var count = entry[1];
        var isActive = activeValues.includes(name);
        return '<button type="button" class="filter-btn ' + (isActive ? 'active' : '') + '" data-filter-param="' + paramName + '" data-filter-value="' + name.replace(/"/g, '&quot;') + '">' +
          '<span class="text-left">' + name + '</span>' +
          '<span class="opacity-70">(' + count + ')</span>' +
          '</button>';
      }).join('');

      container.querySelectorAll('.filter-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var param = this.getAttribute('data-filter-param');
          var value = this.getAttribute('data-filter-value');
          var url = new URL(window.location.href);
          var existing = url.searchParams.getAll(param);

          if (existing.includes(value)) {
            url.searchParams.delete(param);
            existing.filter(function(v) { return v !== value; }).forEach(function(v) {
              url.searchParams.append(param, v);
            });
          } else {
            url.searchParams.append(param, value);
          }
          setFirstGridPage(url);
          window.location.href = url.toString();
        });
      });
    }

    document.querySelectorAll('.collection-filters-container').forEach(function(root) {
      root.querySelectorAll('[data-filter-accordion]').forEach(function(group) {
        var toggle = group.querySelector('[data-filter-toggle]');
        if (!toggle) return;
        toggle.addEventListener('click', function() {
          var isOpen = group.getAttribute('data-open') === 'true';
          setAccordionOpen(group, !isOpen);
        });
      });

      // Keep accordions open when they contain active selections.
      root.querySelectorAll('[data-filter-accordion]').forEach(function(group) {
        var key = group.getAttribute('data-filter-group-key');
        var shouldOpen = false;
        if (key === 'inStock') shouldOpen = inStock;
        if (key === 'finish') shouldOpen = activeFinishes.length > 0;
        if (key === 'size') shouldOpen = activeSizes.length > 0;
        if (key === 'colour') shouldOpen = activeColours.length > 0;
        if (shouldOpen) setAccordionOpen(group, true);
      });

      // Parse metafield data for this specific filter instance.
      var products = [];
      try {
        var dataEl = root.querySelector('[data-collection-metafield-data]');
        if (dataEl) {
          products = JSON.parse(dataEl.textContent || '[]');
        }
      } catch (e) {
        console.error('Failed to parse collection metafield data:', e);
      }

      var finishMap = buildValueMap(products, 'finish');
      var sizeMap = buildValueMap(products, 'size');
      var colourMap = buildValueMap(products, 'colour');

      renderFilterGroup(root, finishMap, activeFinishes, 'finish');
      renderFilterGroup(root, sizeMap, activeSizes, 'size');
      renderFilterGroup(root, colourMap, activeColours, 'colour');

      var inStockBtn = root.querySelector('[data-filter-in-stock]');
      if (inStockBtn) {
        if (inStock) {
          inStockBtn.classList.add('active');
          inStockBtn.textContent = 'Showing in-stock only';
          inStockBtn.setAttribute('data-active', 'true');
        }

        inStockBtn.addEventListener('click', function() {
          var url = new URL(window.location.href);
          if (inStock) {
            url.searchParams.delete('inStock');
          } else {
            url.searchParams.set('inStock', '1');
          }
          setFirstGridPage(url);
          window.location.href = url.toString();
        });
      }

      var clearBtn = root.querySelector('[data-clear-filters]');
      if (clearBtn && (inStock || activeFinishes.length > 0 || activeSizes.length > 0 || activeColours.length > 0)) {
        clearBtn.classList.remove('hidden');
        clearBtn.addEventListener('click', function() {
          var url = new URL(window.location.href);
          url.searchParams.delete('finish');
          url.searchParams.delete('size');
          url.searchParams.delete('colour');
          url.searchParams.delete('inStock');
          setFirstGridPage(url);
          window.location.href = url.toString();
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collections-carousel"] && !Shopify.designMode) return;
  try {
    (function() {
    const carousels = document.querySelectorAll('.collections-carousel');
    
    carousels.forEach(function(carousel) {
      const track = carousel.querySelector('.collections-carousel-track');
      if (!track) return;

      // Set active state based on URL
      function updateActiveState() {
        const currentPath = window.location.pathname;
        const pathHandle = currentPath.split('/').filter(Boolean).pop();
        
        const buttons = carousel.querySelectorAll('.collection-card__button');
        buttons.forEach(function(button) {
          const handle = button.getAttribute('data-collection-handle');
          const isActive = pathHandle === handle;
          if (isActive) {
            button.classList.add('collection-card__button--active');
          } else {
            button.classList.remove('collection-card__button--active');
          }
        });
      }

      updateActiveState();

      // Enable smooth scrolling with mouse wheel
      let isScrolling = false;
      carousel.addEventListener('wheel', function(e) {
        if (isScrolling) return;
        isScrolling = true;
        e.preventDefault();
        carousel.scrollLeft += e.deltaY;
        setTimeout(function() {
          isScrolling = false;
        }, 50);
      }, { passive: false });

      // Touch/swipe support
      let startX = 0;
      let scrollLeft = 0;
      let isDragging = false;

      track.addEventListener('touchstart', function(e) {
        isDragging = true;
        startX = e.touches[0].pageX - track.offsetLeft;
        scrollLeft = carousel.scrollLeft;
      });

      track.addEventListener('touchmove', function(e) {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.touches[0].pageX - track.offsetLeft;
        const walk = (x - startX) * 2;
        carousel.scrollLeft = scrollLeft - walk;
      });

      track.addEventListener('touchend', function() {
        isDragging = false;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cookie-consent"] && !Shopify.designMode) return;
  try {
    (function () {
    var storageKey = 'funky-tiles-cookie-consent';
    var modal = document.getElementById('cookie-modal');
    if (!modal) return;

    try {
      if (window.localStorage.getItem(storageKey)) return;
    } catch (error) {
      return;
    }

    modal.hidden = false;

    function save(choice) {
      try {
        window.localStorage.setItem(storageKey, choice);
      } catch (error) {}

      modal.hidden = true;

      var consent = {
        analytics: choice === 'accepted',
        marketing: choice === 'accepted',
        preferences: choice === 'accepted'
      };

      if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent) {
        window.Shopify.customerPrivacy.setTrackingConsent(consent, function () {});
      }
    }

    modal.addEventListener('click', function (event) {
      var button = event.target.closest('[data-cookie-choice]');
      if (!button) return;
      save(button.getAttribute('data-cookie-choice'));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function() {
    const productCards = document.querySelectorAll('.product-card');
    
    productCards.forEach(card => {
      const addToCartBtn = card.querySelector('[data-action="add-to-cart"]');
      const wishlistBtn = card.querySelector('[data-action="wishlist"]');
      const form = card.querySelector('.product-card__form');
      
      // Add to cart functionality
      if (addToCartBtn && form) {
        addToCartBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          form.submit();
        });
      }
      
      // Wishlist functionality
      if (wishlistBtn) {
        const productId = card.getAttribute('data-product-id');
        const productTitle = card.getAttribute('data-product-title');
        const productHandle = card.getAttribute('data-product-handle');
        const productUrl = card.getAttribute('data-product-url');
        const productPrice = parseInt(card.getAttribute('data-product-price') || '0');
        const productComparePrice = parseInt(card.getAttribute('data-product-compare-price') || '0');
        const productImage = card.getAttribute('data-product-image');
        const productImageSecondary = card.getAttribute('data-product-image-secondary') || productImage;
        const productVariantId = card.getAttribute('data-product-variant-id');
        const productAvailable = card.getAttribute('data-product-available') === 'true';

        // Check if product is already in wishlist
        let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
        const isInWishlist = wishlist.includes(productId);
        
        if (isInWishlist) {
          wishlistBtn.classList.add('active');
          const icon = wishlistBtn.querySelector('.product-card__wishlist-icon');
          if (icon) {
            icon.setAttribute('fill', 'currentColor');
          }
          // On desktop, ensure wishlist button is visible if already in wishlist
          if (window.innerWidth >= 1024) {
            wishlistBtn.style.opacity = '1';
          }
        }

        wishlistBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
          const isActive = this.classList.contains('active');
          const icon = this.querySelector('.product-card__wishlist-icon');
          
          if (isActive) {
            // Remove from wishlist
            wishlist = wishlist.filter(id => id !== productId);
            this.classList.remove('active');
            if (icon) {
              icon.setAttribute('fill', 'none');
            }
            localStorage.removeItem(`product_${productId}`);
            // On desktop, hide wishlist button after removal if not hovering
            if (window.innerWidth >= 1024) {
              this.style.opacity = '';
            }
          } else {
            // Add to wishlist
            if (!wishlist.includes(productId)) {
              wishlist.push(productId);
            }
            this.classList.add('active');
            if (icon) {
              icon.setAttribute('fill', 'currentColor');
            }
            // On desktop, ensure wishlist button stays visible after adding
            if (window.innerWidth >= 1024) {
              this.style.opacity = '1';
            }
            
            // Store product data in localStorage
            const productData = {
              id: productId,
              title: productTitle,
              handle: productHandle,
              url: productUrl,
              featuredImage: productImage,
              images: [productImage, productImageSecondary].filter(Boolean),
              price: productPrice,
              compareAtPrice: productComparePrice > productPrice ? productComparePrice : null,
              variantId: productVariantId,
              available: productAvailable
            };
            console.log('Storing product data:', productData);
            localStorage.setItem(`product_${productId}`, JSON.stringify(productData));
            console.log('Product data stored successfully');
          }
          
          localStorage.setItem('wishlist', JSON.stringify(wishlist));
          
          // Dispatch event to update wishlist components
          window.dispatchEvent(new Event('wishlist-updated'));
        });
      }
      
      // Handle card click to navigate to product page (but allow buttons/links to work)
      const productUrl = card.getAttribute('data-product-url');
      if (productUrl) {
        card.addEventListener('click', function(e) {
          // Don't navigate if clicking on buttons, links, or form elements
          const clickedElement = e.target;
          const isButton = clickedElement.tagName === 'BUTTON' || clickedElement.closest('button');
          const isLink = clickedElement.tagName === 'A' || clickedElement.closest('a');
          const isActionArea = clickedElement.closest('.product-card__actions') || 
                               clickedElement.closest('.product-card__wishlist') ||
                               clickedElement.closest('.product-card__form');
          
          if (isButton || isLink || isActionArea) {
            return;
          }
          
          // Navigate to product page
          window.location.href = productUrl;          
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
